import React, { useState, useEffect } from "react";
import IconButton from "components/common/iconButton";
import { Link, useNavigate } from "react-router-dom";
import {
  Card,
  Col,
  Row,
} from "react-bootstrap"
import AdvanceTable from "components/common/advance-table/advanceTable";
import AdvanceTableSearchBox from "components/common/advance-table/advanceTableSearchBox";
import AdvanceTablePagination from "components/common/advance-table/advanceTablePagination";
import AdvanceTableFooter from 'components/common/advance-table/advanceTableFooter';
import useAdvanceTable from "hooks/useAdvanceTable";
import AdvanceTableProvider from "providers/advanceTableProvider";
import corner4 from "assets/img/illustrations/corner-4.png";
import Background from "components/common/background";
import paths from "routes/paths";
import { useTranslation } from "react-i18next";
import {getInitialPageSize } from "../../assets/js/common";

const Activity = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate(); // Initialize useNavigate hook
  const handleViewDetails = (templateId) => {
    navigate(`${paths.templateDetails.replace(":templateId", templateId)}`);
  };
  const { t, i18n } = useTranslation();

  const columns = [

    {
      accessorKey: "--",
      header: t("templateName"),
      //    cell: ({ row: { original } }) => <span>{original.RelationNumber}</span>
    },
    {
      accessorKey: "--",
      header: t("createdByWithoutcolon"),
      //    cell: ({ row: { original } }) => <span>{original.RelationNumber}</span>
    },
    {
      accessorKey: "--",
      header: t("creationDateWithoutColon"),
      //    cell: ({ row: { original } }) => <span>{original.Name}</span>,
    },
    {
      accessorKey: "--",
      header: t("assignedTo"),
      //    cell: ({ row: { original } }) => <span>{original.Emailaddress1}</span>,
    },
  ];

  const table = useAdvanceTable({
    data,
    columns,
    selection: true,
    sortable: true,
    pagination: true,
    perPage: getInitialPageSize('activityTable')
  });

  return (
    <>
      <AdvanceTableProvider {...table}>
        <Row className="g-3 mb-3">
          <Col lg={12} xxl={12}>
            <Card className="mb-3 h-100">
              <Background image={corner4} className="bg-card" />
              <Card.Body className="position-relative pe-3 pb-2">
                <Row className="flex-between-center">
                  <Col md>
                    <h5 className="mb-2 mb-md-0">{t("templates")}</h5>
                  </Col>
                  <Col xs="auto">
                    <IconButton
                      as={Link}
                      to={paths.newTemplate}
                      variant="primary"
                      size="sm"
                      icon="plus"
                      transform="shrink-3"
                    >
                      <span className="ms-1">{t("newTemplate")}</span>
                    </IconButton>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Card className="mb-3">
          <Card.Header>
            {/* <Row className="flex-between-center">
                   <Col xs={8} sm="auto" className="ms-auto text-end ps-0">
                     <AdvanceTableSearchBox setGlobalFilter={setGlobalFilter} />
                   </Col>
                 </Row> */}
          </Card.Header>
          <Card.Body className="p-0">

            <>
              <AdvanceTable
                headerClassName="bg-200 text-nowrap align-middle"
                rowClassName="align-middle white-space-nowrap"
                tableProps={{
                  bordered: true,
                  striped: true,
                  size: "sm",
                  className: "mb-0 overflow-hidden data-font-size table-hover",
                }}
                getRowProps={(row) => ({
                  onClick: () => handleViewDetails(row.original.acticityId),
                  style: { cursor: "pointer" }
                })}
              />
              {/* Always show headers, even if no data */}
              {data.length === 0 ? (
                <div className="text-center pt-4">
                  {t("noDataAvailableText")}
                </div>
              ) : null}
            </>
          </Card.Body>
          <Card.Footer>
            {/* <AdvanceTablePagination /> */}
            <AdvanceTableFooter
              rowInfo
              navButtons
              rowsPerPageSelection
              tableKey="activityTable"
            />
          </Card.Footer>
        </Card>
      </AdvanceTableProvider>
    </>
  );
};
export default Activity;